import { render, staticRenderFns } from "./inquiryComplete.vue?vue&type=template&id=cb1b71de&scoped=true&"
import script from "./inquiryComplete.vue?vue&type=script&lang=js&"
export * from "./inquiryComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b71de",
  null
  
)

export default component.exports